module.exports = __webpack_public_path__ + "static/images/challenge.aebaf6f021ab320d1b4663c00a9ff564.png";